// extracted by mini-css-extract-plugin
export default {"emailStatus":"EmailStatus_emailStatus__kh5jz"};